<div *ngIf="line1" class="item-description">{{ line1 }}</div>
<div *ngIf="line2" class="item-description">{{ line2 }}</div>
